import { Terminal } from './Terminal';
import { IPropertyEntity } from './IPropertyEntity';

export class Berth implements IPropertyEntity {
    constructor(
        berthId: number,
        terminalId: number | null,
        terminal: Terminal | null,
        berthShortName: string | null,
        berthLongName: string | null,
        imosBerthId: number | null,
        imosExternalRef: string | null,
        changedBy: string,
        isDeleted: boolean,
        lastUpdated: Date | null
    ) {
        this.berthId = berthId;
        this.terminalId = terminalId;
        this.terminal = terminal;
        this.berthShortName = berthShortName;
        this.berthLongName = berthLongName;
        this.berthDisplayName = this.berthLongName ? this.berthLongName : this.berthShortName;
        this.imosBerthId = imosBerthId;
        this.imosExternalRef = imosExternalRef;
        this.changedBy = changedBy;
        this.isDeleted = isDeleted;
        this.pKPortId = 0;
        this.pKBerthId = berthId;
        this.pKTerminalId = 0;
        this.pKBerthRestrictionId = 0;
        this.lastUpdated = lastUpdated;
    }
    berthId: number;
    terminalId: number | null;
    terminal: Terminal | null;
    berthShortName: string | null;
    berthLongName: string | null;
    berthDisplayName: string | null;
    imosBerthId: number | null;
    imosExternalRef: string | null;
    changedBy: string;
    isDeleted: boolean;
    pKPortId: number;
    pKBerthId: number;
    pKTerminalId: number;
    pKBerthRestrictionId: number;
    lastUpdated: Date | null;
}
